//import barba from '@barba/core';
//import AOS from 'aos';
import LazyLoad from 'vanilla-lazyload';
import LocomotiveScroll from 'locomotive-scroll';
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, Controller, A11y } from 'swiper';
//import { gsap } from 'gsap/dist/gsap';

export default {
  bodyInit() {
    var _body                   = 'body';
    var _header                 = 'header.body__header';

    /**
     * MOBILE DETECT
     **/
    function renderMobileBodyClassOnLoad() {
      $( window ).on( 'load', function() {
        if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent ) ) {
          $( _body ).addClass( _body +'--device-is-mobile' );
        }
      });
    }

    renderMobileBodyClassOnLoad();

    /**
     * HEADER
     **/
    function header() {
      let _menu_target            = 'menu';

      function menuToggleOnClick() {
        $( document ).on( 'click', '.js--toggle-menu', function( event ) {
          let _text_active            = $( this ).data( 'text-active' );
          let _text_default           = $( this ).data( 'text-default' );
          let _controls               = $( this ).attr( 'aria-controls' );

          if ( $( this ).attr( 'aria-expanded' ) === 'false' ) {
            if ( typeof _text_active !== 'undefined' ) {
              $( this ).find( '.button__text' ).text( _text_active );
            }

            $( this ).attr( 'aria-expanded', true );
            $( '#' + _controls ).attr( 'aria-expanded', true );
            $( '#' + _controls ).attr( 'tabindex', 1 );
            $( _body ).addClass( _body +'--'+ _controls +'-is-active' );
          } else {
            if ( typeof _text_default !== 'undefined' ) {
              $( this ).find( '.button__text' ).text( _text_default );
            }

            $( this ).attr( 'aria-expanded', false );
            $( '#' + _controls ).attr( 'aria-expanded', false );
            $( '#' + _controls ).attr( 'tabindex', 0 );
            $( _body ).removeClass( _body +'--'+ _controls +'-is-active' );
          }

          event.preventDefault();
          return false;
        });
      }

      function menuCloseOnEsc() {
        $( document ).on( 'keyup', function( event ) {
          if ( $( '.body--'+ _menu_target +'-is-active' ).length >= 1 && ( event.keyCode == 27 ) ) {
            $( '*[aria-controls="'+ _menu_target +'"][aria-expanded="true"]' ).click();
          }
        });
      }

      function menuItemOnClick() {
        $( document ).on( 'click', '.js--toggle-submenu[aria-haspopup="true"]', function( event ) {
          let _aria_expanded          = $( this ).attr( 'aria-expanded' );

          $( this ).closest( '*[role="menubar"]' ).find( '.link--has-sublist[aria-haspopup="true"][aria-expanded="true"]' ).removeClass( 'link--is-current' ).attr( 'aria-expanded', false );
          if ( _aria_expanded === 'false' ) {
            $( this ).addClass( 'link--is-current' ).attr( 'aria-expanded', true ).parent().addClass( 'item--is-active' );
            $( _body ).addClass( _body +'--dropdown-is-active' );
          } else {
            $( this ).removeClass( 'link--is-current' ).attr( 'aria-expanded', false ).parent().removeClass( 'item--is-active' );
            $( _body ).removeClass( _body +'--dropdown-is-active' );
          }

          event.preventDefault();
          return false;
        });
      }

      function menuItemCloseOnEsc() {
        $( document ).on( 'keyup', function( event ) {
          if ( $( '.body--dropdown-is-active' ).length >= 1 && ( event.keyCode == 27 ) ) {
            $( '.link--has-sublist[aria-haspopup="true"][aria-expanded="true"]' ).removeClass( 'link--is-current' ).attr( 'aria-expanded', false ).parent().removeClass( 'item--is-active' );
          }
        });
      }

      function menuItemCloseOnClick() {
        $( document ).on( 'click', function( event ) {
          let _item_expanded          = $( '.js--toggle-submenu[aria-haspopup="true"][aria-expanded="true"]' );

          if ( _item_expanded !== event.target && !_item_expanded.has( event.target ).length ) {
            _item_expanded.removeClass( 'link--is-current' ).attr( 'aria-expanded', false );
          }
        });
      }

      if ( $( _header ).length === 1 ) {
        menuToggleOnClick();
        menuCloseOnEsc();
        menuItemOnClick();
        menuItemCloseOnEsc();
        menuItemCloseOnClick();
      }
    }

    header();

    /**
     * OPENHOURS
     **/
    function openHours() {
      let _openhours_target       = 'aside--openhours';

      function openHoursToggleOnClick() {
        $( document ).on( 'click', '.js--toggle-openhours', function( event ) {
          let _text_active            = $( this ).data( 'text-active' );
          let _text_default           = $( this ).data( 'text-default' );
          let _controls               = $( this ).attr( 'aria-controls' );

          if ( $( this ).attr( 'aria-expanded' ) === 'false' ) {
            if ( typeof _text_active !== 'undefined' ) {
              $( this ).find( '.button__text' ).text( _text_active );
            }

            $( this ).attr( 'aria-expanded', true );
            $( '#' + _controls ).attr( 'aria-expanded', true );
            $( '#' + _controls ).attr( 'tabindex', 1 );
            $( _body ).addClass( _body +'--'+ _controls +'-is-active' );
          } else {
            if ( typeof _text_default !== 'undefined' ) {
              $( this ).find( '.button__text' ).text( _text_default );
            }

            $( this ).attr( 'aria-expanded', false );
            $( '#' + _controls ).attr( 'aria-expanded', false );
            $( '#' + _controls ).attr( 'tabindex', 0 );
            $( _body ).removeClass( _body +'--'+ _controls +'-is-active' );
          }

          event.preventDefault();
          return false;
        });
      }

      function openHoursCloseOnEsc() {
        $( document ).on( 'keyup', function( event ) {
          if ( $( '.body--'+ _openhours_target +'-is-active' ).length >= 1 && ( event.keyCode == 27 ) ) {
            $( '*[aria-controls="'+ _openhours_target +'"][aria-expanded="true"]' ).click();
          }
        });
      }

      if ( $( '#aside--openhours' ).length === 1 ) {
        openHoursToggleOnClick();
        openHoursCloseOnEsc();
      }
    }

    openHours();

  },
  wrapInit() {
    //var _window                 = window;
    var _body                   = 'body';
    var _swipers                = [];

    /**
     * LAZYLOAD
     **/
    var _lazyload                 = new LazyLoad({
      class_loading:                'medium--loading',
      class_loaded:                 'medium--loaded',
      elements_selector:            '.js--selector-lazy',
      threshold:                    0,
    });

    /**
     * SCROLL
     **/
    var _scroll                 = new LocomotiveScroll({
      el:                         document.querySelector( '[data-scroll-container]' ),
      smooth:                     true,
      getDirection:               true,
    });

    /**
     * DIRECTION ON SCROLL
     **/
    function directionOnScroll() {
      _scroll.on( 'scroll', ( _instance ) => {
        if ( _instance.scroll.y >= 1 ) {
          if ( _instance.direction === 'down' ) {
            $( _body ).attr( 'data-scroll-direction', 'down' );
          }

          if ( _instance.direction === 'up' ) {
            $( _body ).attr( 'data-scroll-direction', 'up' );
          }
        }
      });
    }

    directionOnScroll();

    /**
     * SLIDER
     **/
    function slider() {
      Swiper.use(
        [
          Navigation,
          Pagination,
          Scrollbar,
          Autoplay,
          Controller,
          A11y,
        ]
      );

      const _sliders              = document.querySelectorAll( '.js--selector-slider' );

      function sliderArgs() {
        for ( let i = 0; i < _sliders.length; i++ ) {
          let _slider_selector        = _sliders[i];

          var _updateOnWindowResize   = true;
          var _initialSlide           = 0;
          var _direction              = 'horizontal';
          var _speed                  = 750;
          var _allowTouchMove         = true;
          var _autoHeight             = false;
          var _uniqueNavElements      = false;
          var _effect                 = 'slide';

          var _spaceBetween           = 32;
          var _slidesPerView          = 1;
          var _centeredSlides         = false;

          var _loop                   = false;
          var _loopedSlides           = false;

          var _breakpoints            = false;

          var _containerModifierClass = 'slider--';
          var _slideClass             = 'slider__slide';
          var _slideActiveClass       = 'slider__slide--is-active';
          var _slideDuplicateActiveClass = 'slider__slide-duplicate--is-active';
          var _slideVisibleClass      = 'slider__slide--is-visible';
          var _slideDuplicateClass    = 'slider__slide-duplicate';
          var _slideNextClass         = 'slider__slide--is-next';
          var _slideDuplicateNextClass = 'slider__slide-duplicate--is-next';
          var _slidePrevClass         = 'slider__slide--is-prev';
          var _slideDuplicatePrevClass = 'slider__slide-duplicate--is-prev';
          var _slideBlankClass        = 'slider__slide--is-invisible';
          var _wrapperClass           = 'slider__slides';

          var _navigation             = false;

          var _pagination             = false;

          var _scrollbar              = false;
          //var _scrollbar_lockClass    = 'slider__scrollbar--lock';
          //var _scrollbar_dragClass    = 'slider__scrollbar--drag';

          var _autoplay               = false;

          var _coverflowEffect        = false;

          /**
           * GALLERY
           **/
          if ( _slider_selector.classList.contains( 'slider--medium' ) ) {
            _spaceBetween               = 0;
            _slidesPerView              = 1;
            _navigation                 = {
              nextEl:                     _slider_selector.querySelector( '.slider__button.button--next' ),
              prevEl:                     _slider_selector.querySelector( '.slider__button.button--prev' ),
              disabledClass:              'button--is-disabled',
              hiddenClass:                'button--is-hidden',
            };
          }

          /**
           * CATALOGUE
           **/
          if ( _slider_selector.classList.contains( 'slider--catalogue' ) ) {
            _spaceBetween               = 0;
            _slidesPerView              = 1;
            _breakpoints                = {
              576:                          {
                slidesPerView:                1,
              },
              992:                          {
                slidesPerView:                1,
              },
            };
            _navigation                 = {
              nextEl:                     _slider_selector.querySelector( '.slider__button.button--next' ),
              prevEl:                     _slider_selector.querySelector( '.slider__button.button--prev' ),
              disabledClass:              'button--is-disabled',
              hiddenClass:                'button--is-hidden',
            };
            _pagination                 = {
              el:                           _slider_selector.querySelector( '.slider__controller--fraction' ),
              type:                         'fraction',
              bulletClass:                  null,
              bulletActiveClass:            'text--is-active',
              modifierClass:                'text--',
              currentClass:                 'text--is-current',
              totalClass:                   'text--is-total',
              renderFraction:                 function( currentClass, totalClass )
              {
                return '<span class="slider__text '+ currentClass +'" aria-hidden="true"></span><span class="slider__text '+ totalClass +'" aria-hidden="true"></span>';
              },
            };

            /**
             * POST
             **/
            if ( _slider_selector.classList.contains( 'slider--post' ) ) {
              _slidesPerView              = 1;
              _breakpoints                = {
                576:                          {
                  slidesPerView:                1,
                },
                768:                          {
                  slidesPerView:                1,
                },
                992:                          {
                  slidesPerView:                1,
                },
              };
            }
          }

          var _swiper                 = new Swiper( _slider_selector.querySelector( '.slider__wrapper' ),
            {
              updateOnWindowResize:       _updateOnWindowResize,
              initialSlide:               _initialSlide,
              direction:                  _direction,
              speed:                      _speed,
              allowTouchMove:             _allowTouchMove,
              autoHeight:                 _autoHeight,
              uniqueNavElements:          _uniqueNavElements,
              effect:                     _effect,
              spaceBetween:               _spaceBetween,
              slidesPerView:              _slidesPerView,
              centeredSlides:             _centeredSlides,
              loop:                       _loop,
              loopedSlides:               _loopedSlides,
              breakpoints:                _breakpoints,
              containerModifierClass:     _containerModifierClass,
              slideClass:                 _slideClass,
              slideActiveClass:           _slideActiveClass,
              slideDuplicateActiveClass:  _slideDuplicateActiveClass,
              slideVisibleClass:          _slideVisibleClass,
              slideDuplicateClass:        _slideDuplicateClass,
              slideNextClass:             _slideNextClass,
              slideDuplicateNextClass:    _slideDuplicateNextClass,
              slidePrevClass:             _slidePrevClass,
              slideDuplicatePrevClass:    _slideDuplicatePrevClass,
              slideBlankClass:            _slideBlankClass,
              wrapperClass:               _wrapperClass,
              navigation:                 _navigation,
              pagination:                 _pagination,
              scrollbar:                  _scrollbar,
              autoplay:                   _autoplay,
              coverflowEffect:            _coverflowEffect,
              on:
                {
                  init: function() {
                    _lazyload.update();
                    _scroll.update();
                  },
                },
            }
          );

          _swipers.push( _swiper );
        }
      }

      if ( document.querySelectorAll( '.js--selector-slider' ).length >= 1 ) {
        sliderArgs();
      }
    }

    slider();
  },
  init() {
    this.bodyInit();
    this.wrapInit();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js